module.exports = new __parcel__URL__("virtual-agent-browse-conversations-app-skeleton.tpl.9f030add.svg").toString();